import CryptoJS from "crypto-js";

const { VUE_APP_POINT, VUE_APP_SDK_APPID, VUE_APP_SDK_APPKEY } =
  process.env;

const Information: any = {};
const sdkVer = "1.0.10";
const appVer = "0.0.1";
const sdkChannelId = "0";
export const SDK_APP_ID = VUE_APP_SDK_APPID || "";
export const SDK_APP_KEY = VUE_APP_SDK_APPKEY || "";
const sdkAppId = SDK_APP_ID;
const sdkAppKey = SDK_APP_KEY;
export interface BuryingOptions {
  appid?: string;
  appkey?: string;
  channel?: string;
  deviceType?: string;
}

const sdkUrl = `${VUE_APP_POINT || "https://log.tj.996sdk.com"}/v1/event`;

if (localStorage.getItem("deviceId")) {
  Information.id = localStorage.getItem("deviceId");
}

function resolveCredentials(options?: BuryingOptions) {
  const opts = options || {};
  return {
    appid: opts.appid || sdkAppId,
    appkey: opts.appkey || sdkAppKey,
    channel: opts.channel !== undefined ? opts.channel : sdkChannelId,
    deviceType: opts.deviceType || Information.type || getDeviceType(),
  };
}

/** 获取设备类型：pc / android / ios */
export function getDeviceType() {
  const cached = localStorage.getItem("device");
  if (cached) return cached;
  const u = navigator.userAgent;
  const isIPad =
    /iPad/i.test(u) ||
    (/Macintosh/i.test(u) && Number(navigator.maxTouchPoints) > 1);
  const isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1;
  const isIOS =
    !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) || isIPad;
  const isMobileUA =
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(u) ||
    isIPad;
  if (!isMobileUA) return "pc";
  if (isAndroid) return "android";
  if (isIOS) return "ios";
  return "pc";
}

function stringifyProperties(obj: any) {
  const result: any = {};
  Object.keys(obj || {}).forEach((key) => {
    const val = obj[key];
    result[key] = val === undefined || val === null ? "" : String(val);
  });
  return result;
}

function uuid(appKey: string) {
  const uuid996 = localStorage.getItem("uuid996" + appKey);
  let i = "";
  if (uuid996 == null) {
    i = guid();
    localStorage.setItem("uuid996" + appKey, i);
  } else {
    i = uuid996;
  }
  return i;
}
function guid() {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
    const r = Math.floor(Math.random() * 16);
    const v = c === "x" ? r : Math.floor(r % 4 + 8);
    return v.toString(16);
  });
}
function getNetworkType() {
  const ua = navigator.userAgent;
  const networkMatch = ua.match(/NetType\/\w+/);
  let networkStr = networkMatch ? networkMatch[0] : "NetType/other";
  networkStr = networkStr.toLowerCase().replace("nettype/", "");
  let networkType;
  switch (networkStr) {
    case "wifi":
      networkType = "wifi";
      break;
    case "5g":
      networkType = "5G";
      break;
    case "4g":
      networkType = "4G";
      break;
    case "3g":
      networkType = "3G";
      break;
    case "3gnet":
      networkType = "3G";
      break;
    case "2g":
      networkType = "2G";
      break;
    default:
      networkType = "UNKNOWN";
  }
  return networkType;
}
function browserRedirect() {
  const sUserAgent = navigator.userAgent;
  const isWin =
    navigator.platform === "Win32" || navigator.platform === "Windows";
  const isMac =
    navigator.platform === "Mac68K" ||
    navigator.platform === "MacPPC" ||
    navigator.platform === "Macintosh" ||
    navigator.platform === "MacIntel";
  if (isMac) return "Mac";
  const isUnix = navigator.platform === "X11" && !isWin && !isMac;
  if (isUnix) return "Unix";
  const isLinux = String(navigator.platform).indexOf("Linux") > -1;
  if (isLinux) return "Linux";
  if (isWin) {
    const isWin2K =
      sUserAgent.indexOf("Windows NT 5.0") > -1 ||
      sUserAgent.indexOf("Windows 2000") > -1;
    if (isWin2K) return "Win2000";
    const isWinXP =
      sUserAgent.indexOf("Windows NT 5.1") > -1 ||
      sUserAgent.indexOf("Windows XP") > -1;
    if (isWinXP) return "WinXP";
    const isWin2003 =
      sUserAgent.indexOf("Windows NT 5.2") > -1 ||
      sUserAgent.indexOf("Windows 2003") > -1;
    if (isWin2003) return "Win2003";
    const isWinVista =
      sUserAgent.indexOf("Windows NT 6.0") > -1 ||
      sUserAgent.indexOf("Windows Vista") > -1;
    if (isWinVista) return "WinVista";
    const isWin7 =
      sUserAgent.indexOf("Windows NT 6.1") > -1 ||
      sUserAgent.indexOf("Windows 7") > -1;
    if (isWin7) return "Win7";
    const isWin10 =
      sUserAgent.indexOf("Windows NT 10") > -1 ||
      sUserAgent.indexOf("Windows 10") > -1;
    if (isWin10) return "Win10";
    const isWin11 =
      sUserAgent.indexOf("Windows NT 11") > -1 ||
      sUserAgent.indexOf("Windows 11") > -1;
    if (isWin11) return "Win11";
  }
  return "other";
}
export function Burying(key: any, options?: BuryingOptions) {
  const creds = resolveCredentials(options);
  const deviceType = creds.deviceType;
  // PC 盒子环境可能注入 deviceID
  if (!Information.id && (window as any).deviceID) {
    Information.id = (window as any).deviceID;
  }
  const burying = JSON.stringify({
    appid: creds.appid,
    sdk_ver: sdkVer,
    app_ver: appVer,
    channel: creds.channel,
    boxid: key.boxid || "",
    device: {
      type: deviceType,
      model: Information.model || deviceType,
      id: Information.id || uuid(creds.appkey),
      id1: "",
      id2: "",
      id3: "",
      os: Information.os || browserRedirect(),
      width: window.innerWidth,
      height: window.innerHeight,
      lang: Information.lang || navigator.language,
      idfv: Information.idfv || "",
    },
    net_type: Information.net_type || getNetworkType(),
    user: {
      id: String(key.uid),
    },
    event: {
      time: Math.floor(Date.now() / 1000),
      name: key.eventname,
      type: key.eventtype,
    },
    properities: stringifyProperties({
      device: deviceType,
      ...key.properities,
    }),
  });
  const headers = objKeySort(burying, creds);
  localStorage.setItem(
    "SDK-INFO",
    JSON.stringify({
      ...JSON.parse(burying),
      "sdk_app_key": creds.appkey,
      "x-996sdk-nonce": headers["x-996sdk-nonce"],
      "sdk_url": sdkUrl,
    })
  );
  ajax("post", sdkUrl, burying, headers);
  return burying;
}

function ajax(method, url, params, header) {
  const xhr = new XMLHttpRequest();
  xhr.open(method, url);
  Object.keys(header).forEach((key) => {
    xhr.setRequestHeader(key, header[key]);
  });
  if (method.toLowerCase() === "get") {
    xhr.send(params);
  } else {
    xhr.setRequestHeader("Content-Type", "application/json");
    xhr.send(params);
  }
  xhr.onreadystatechange = () => {
    if (xhr.readyState === 4 && xhr.status === 200) {
      // success
    }
  };
}

function getRamNumber() {
  let result = "";
  for (let i = 0; i < 16; i++) {
    result += Math.floor(Math.random() * 16).toString(16);
  }
  return result.toUpperCase();
}
function objKeySort(body: string, creds: any) {
  const headers: any = {
    "x-996sdk-appid": creds.appid,
    "x-996sdk-algo": "MD5",
    "x-996sdk-nonce": getRamNumber(),
    "x-996sdk-timestamp": Math.floor(Date.now() / 1000),
  };
  const xargs = ["POST", "/v1/event"];
  Object.keys(headers)
    .sort()
    .forEach((key) => {
      xargs.push(key + "=" + headers[key]);
    });
  xargs.push(body);
  xargs.push("key=" + creds.appkey);
  headers["x-996sdk-sign"] = CryptoJS.MD5(xargs.join("\n")).toString();
  return headers;
}
